// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const foundingMemberApi = baseApi.injectEndpoints({
  credentials: "include",
  endpoints: (builder) => ({
    addFM: builder.mutation({
      query: (data) => {
        return {
          url: "founding-members",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    // updateEA: builder.mutation({
    //   query: ({ data, id }) => {
    //     return {
    //       url: `early-access-incentives/${id}`,
    //       method: "PATCH",
    //       body: data,
    //       headers: {
    //         "Content-type": "application/json; charset=UTF-8",
    //       },
    //     };
    //   },
    //   // invalidatesTags: ['User'],
    // }),
    deleteFM: builder.mutation({
      query: (id) => {
        return {
          url: `founding-members/${id}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getAllFM: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams(query).toString();
        return {
          url: `founding-members?${queryString}`, // todo:
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useAddFMMutation,
  // useUpdateFMMutation,
  useDeleteFMMutation,
  useGetAllFMQuery,
} = foundingMemberApi;
